<template>
  <div>
    <img v-if="previewMode" src="data:image/png;base64,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"/>
    <div v-if="!previewMode" >
      <div ref="container" v-html="comment"></div>
    </div>
  </div>
</template>
<script>
  export default
  {
    name:'form-comment-list-min',
    data() {
      let config=this.$options.config;
      let previewMode=config.$previewMode;
      let businessId=config.getData().businessId
      return {
        previewMode:previewMode,
        businessId:businessId,
        comment:'',
        commentList:[]
      }
    },
    created() {

    },
    mounted() {
      let me=this;
      let cfg=this.$options.config;
      if(cfg.getFormObject){
        let form=cfg.getFormObject();
        if (form && form.$commentMinData) {
          this.renderData(form.$commentMinData);
        }
      }
      $(this.$refs.container).on("click","span[commentid]",function(){
        let span=$(this);
        let commentId=span.attr("commentid");
        let comment=_.find(me.commentList,{id: commentId})
        me.editComment(comment);
      })
    },
    methods: {
       renderData(reList){
        let me=this;
        let config=this.$options.config.getConfig();

        if(!me.previewMode){
          let params={};
          params.businessId=me.businessId;
          let taskName=[];
          let category=[];

          let newList=[];

          let categoryMap=me.mwLodash.groupBy(reList, function(item){
            return item.category;
          })
          let taskNameMap=me.mwLodash.groupBy(reList, function(item){
            return item.taskName;
          })

          if(config.typeMark && config.typeMark=='1'){
            if(config.activityName){
              category=config.activityName.split(',');
              category.forEach(v=>{
                if(categoryMap[v]){
                  categoryMap[v].forEach(v1=>{
                    newList.push(v1);
                  })
                }
              })
            }else{
              return
            }
          }else{
            if(config.activityName){
              taskName=config.activityName.split(',');
              taskName.forEach(v=>{
                if(taskNameMap[v]){
                  taskNameMap[v].forEach(v1=>{
                    newList.push(v1);
                  })
                }
              })
            }else{
              return
            }
          }
          let dir = "desc";
          if(window.$Env && $Env.formCommentDirAsc){
            dir = "asc"
          }
          if(config.fetchMode && config.fetchMode=='1'){ //最新
            newList=me.mwLodash.orderBy(newList,['createTime'],['desc']);
            if(newList.length>0){
              newList=[newList[0]]
            }
          }else if(config.fetchMode && config.fetchMode=='3'){ //个人最新
            let creatorMap=me.mwLodash.groupBy(newList, function(item){
              return item.creator ? item.creator: item.assigneeName;
            })
            let keys=me.mwLodash.keys(creatorMap);
            newList=[];
            keys.forEach(v=>{
              creatorMap[v] = me.mwLodash.orderBy(creatorMap[v],['createTime'],['desc']);
              newList.push(creatorMap[v][0]);
            })
            newList=me.mwLodash.orderBy(newList,['createTime'],[dir]);
          }else{
            newList=me.mwLodash.orderBy(newList,['createTime'],[dir]);
          }
          let form=me.$options.config.getForm();
          form.fireEvent("beforerenderemincomment",me,newList,reList);
          me.doRenderComments(newList);
        }
      },
      doRenderComments(newList){
        let me = this;
        me.commentList=newList ||[];
        let config=me.$options.config.getConfig();
        let $form=me.$options.config.getForm();
        let isMultiComment= $form.activity && $form.activity.moreCommentSwitch==="1"; //是否可填写多条意见
        let taskId=$form.taskId;
        let showEditBtn=config.showEditBtn==="1";
        let format=config.displayFormat;
        let comments='';
        let comment;
        if(newList.length>0){
          let isEn = window.$currentBrowserLanguage === 'en';
          function getTransCreator(r) {
            return isEn?(r.Englishname || r.creator):r.creator;
          }
          function getTransDepartment(r) {
            return isEn?(r.departmentEnglishname || r.department):r.department;
          }
          for(let i=0;i<newList.length;i++){
            let v1=newList[i];
            comment='';
            if(v1.contentType==="jpg"){
              comment=format.replace(/\[办理意见\]/g,'<image  height=100 src="data:image/jpg;base64,' + v1.content + '">');
            }else{
              if(v1.content){
                  if(format.indexOf('[办理意见]') != -1){
                    comment=format.replace(/\[办理意见\]/g,MW.htmlEncode(v1.content));
                  }else{
                    comment =format.replace(/\[办理意见\]/g,'');
                  }
              }else{
                comment =format.replace(/\[办理意见\]/g,'');
              }
            }
            if(format.indexOf('[办理人]') != -1){
              comment=comment.replace(/\[办理人\]/g,v1.creator ?getTransCreator(v1) :v1.assigneeName);
            }
            if(format.indexOf('[单位]') != -1){
              comment=comment.replace(/\[单位\]/g,$lang(v1.unit));
            }
            if(format.indexOf('[部门]') != -1){
              if(v1.unit!=v1.department)
                comment=comment.replace(/\[部门\]/g,getTransDepartment(v1));
              else
                comment=comment.replace(/\[部门\]/g,"");
            }
            if(format.indexOf('[意见日期]') != -1){
              comment=comment.replace(/\[意见日期\]/g,v1.createTime.substring(0,10));
            }
            if(format.indexOf('[意见时间]') != -1){
              comment=comment.replace(/\[意见时间\]/g,v1.createTime);
            }
            if(format.indexOf('[意见时间分]') != -1){
              comment=comment.replace(/\[意见时间分\]/g,v1.createTime.substring(0,16));
            }
            comment=comment.replace(/\[时间格式\s*:\s*([^\]]+)\]/g,function(str,format){
              return moment(v1.createTime,"YYYY-MM-dd hh:mm:ss").format(format);
            });
            if (showEditBtn && isMultiComment && taskId === v1.taskId) {
              comment+=`<span commentid="${v1.id}" style="color:blue;cursor:pointer;margin-left:10px">编辑</span>`
            }
            //表单意见域显示换行符
            if(window.$Env && window.$Env.formCommentShowEnter && window.$Env.formCommentShowEnter==true){
              comment = comment.replace(/\n/g,"<br/>");
              comment = comment.replace(/ /g,"&nbsp;");
            }
            if (config.displayMode === "inline") {
              comments+='<span>'+comment+'</span>';
            } else {
              comments+='<div>'+comment+'</div>';
            }
          }
          me.comment=comments;
        }else{
          me.comment = "";
        }
      },
      editComment(comment) {
         let me=this;
         if(!comment || !comment.id)return;
        PF.prompt("","修改意见",{inputType:"textarea",inputValue:comment.content,closeOnClickModal:false})
          .then(r=>{
            PF.fsrv("pintervene.srv.updateComment",[comment.id],{content:r.value},{}).then(()=>{
              comment.content=r.value;
              me.doRenderComments(me.commentList);
            });
          })
          .catch(()=>{});
      }
    },
    destroyed(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/comment-min.vue